(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["puffy-mobile"] && !Shopify.designMode) return;
  try {
    function puffyMobileInit(){
  const catalog=document.querySelector('.home-catalog');
  const hero=document.querySelector('.autoplay-hero');
  if(catalog&&hero){
    const marker=document.createElement('div');
    marker.hidden=true;
    catalog.before(marker);
    const media=window.matchMedia('(max-width:720px)');
    const place=()=>{if(media.matches)hero.after(catalog);else marker.after(catalog)};
    place();media.addEventListener('change',place);
  }
  document.querySelectorAll('.puffy-mobile-menu').forEach(menu=>{
    document.addEventListener('click',event=>{if(!menu.contains(event.target))menu.open=false});
    menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus()}});
  });
  const shortcut=document.querySelector('.puffy-mobile-buy a');
  if(shortcut)shortcut.addEventListener('click',()=>{const form=document.getElementById('puffy-buy');if(form)form.focus({preventScroll:true})});
  const target=document.querySelector('.puffy-dimensions');
  const description=document.querySelector('.product-description');
  if(target&&description){
    const lines=description.textContent.split('\n').map(line=>line.trim()).filter(Boolean);
    const fields=[['length',/^Assembled Length\s*\(in\.\)\s*:\s*([\d.]+)$/i,' in'],['width',/^Assembled Width\s*\(in\.\)\s*:\s*([\d.]+)$/i,' in'],['height',/^Assembled Height\s*\(in\.\)\s*:\s*([\d.]+)$/i,' in'],['weight',/^Product Weight\s*\(lbs\.\)\s*:\s*([\d.]+)$/i,' lb']];
    const list=document.createElement('dl');
    fields.forEach(([key,pattern,unit])=>{const found=lines.map(line=>line.match(pattern)).find(Boolean);if(!found)return;const dt=document.createElement('dt');dt.textContent=target.dataset[key];const dd=document.createElement('dd');dd.textContent=found[1]+unit;list.append(dt,dd)});
    if(list.children.length){const heading=document.createElement('h3');heading.textContent=target.dataset.heading;target.append(heading,list);target.hidden=false}
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',puffyMobileInit);else puffyMobileInit();
  } catch(e) { console.error(e); }
})();

})();
